import React from 'react';
import BaseComponent from '../../common/BaseComponent/BaseComponent';


import styles from './NoCompanySelectedPopup.scss';

import CloseButton from "../../common/primitives/CloseButton";
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {__t} from '../../common/lang/text-resource';

class NoCompanySelectedPopup extends BaseComponent {
	visible = false;
	callBack = null;

	constructor() {
		super(...arguments, 'NoCompanySelectedPopup');
	}

	onEsc = (event) => {
		if (this.visible) {
			if (event.keyCode === 27) {
				this.close();
			}
		}
	};

	componentDidMount() {
		super.componentDidMount();
		document.addEventListener('keydown', this.onEsc, false);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.onEsc, false);
	}

	close = () => {
		this.visible = false;
		this.eventRaise('NoCompanySelectedPopupOpened', {visible: false});
		this.forceUpdate();
	};

	continue = event => {
		this.close();
		this.eventRaise('NoCompanySelectedPopupOpened', {visible: false});
		if (this.callBack) {
			this.callBack(event);
		}
	};

	showPopup = (callback) => {

		const {companiesData, loggedIn} = this.context.get('ComponentInvoiceBlock').componentData;
		const selectedInvoiceMode = this.context.get('ComponentInvoiceBlock' + 'smode');

		const hasCompanies = companiesData.length > 0;
		if (loggedIn && hasCompanies) {
			if (selectedInvoiceMode === 'without_invoice') {
				this.visible = true;
				this.eventRaise('NoCompanySelectedPopupOpened', {visible: true});
				this.callBack = callback;
				this.forceUpdate();
				return false;
			}
		}

		callback();
	};

	render() {
		if (this.visible) {
			document.body.style.overflow = "hidden"
		} else {
			document.body.style.overflow = "auto";
			return null;
		}

		return (
		  <div className={styles.container}>
			  <div>
				  <div className={styles.closeButton}>
					  <CloseButton onClick={this.close} altText={"Close"}/>
				  </div>
				  <div className={styles.content}>
					  <div data-layout="margin-top--md margin-bottom--lg">
						  <h1>{__t('Избор на фирма')}</h1>
						  {__t('вашия-клиентски-профил-е-свързан-с-една-или-повеч999983')}
						  <br/><br/>
						  <div data-layout="row start center gutter-none margin-top--smm margin-bottom--md">
							  <div data-layout="col 12 text-center">
								  <Button
									onClick={this.close}
									name={'do_select_company'}
									value={__t('Избор на фирма')}/>
							  </div>
						  </div>
						  <div data-layout="row start center gutter-none">
							  <div data-layout="col 12 text-center">
								  <Button
									onClick={this.continue}
									name={'do_select_company'}
									value={__t('Продължи с поръчка')}
									className={`${buttons.buttonLink} ${buttons.action} ${styles.continueButton}`}/>
							  </div>
						  </div>
					  </div>
				  </div>
			  </div>
		  </div>
		)
	}
}


// React Context binding
NoCompanySelectedPopup.contextType = ContextDataStore;

export default NoCompanySelectedPopup;